import _ from 'lodash';
import { camelCase, startCase } from 'lodash/string';

export default class LedgerListCtrl {
  constructor(Ledger) {
    this.volumeLabels = Ledger.volumeLabels;
  }

  $onInit() {
    this.sortByAlpha = this.isAlpha();
  }

  isAlpha() {
    return _.get(this, 'categoryOrder.type') === 'ALPHABETICAL';
  }

  reorderLedger(list, ledger) {
    const index = list.indexOf(ledger);

    list.splice(index, 1);

    const newIndex = _.findIndex(list, { id: ledger.id });
    const isLast = newIndex === list.length - 1;
    const nextLedger = isLast ? list[newIndex - 1] : list[newIndex + 1];

    this.onReorder(ledger.id, nextLedger.id, isLast);
  }

  getLedgerCount() {
    return this.ledgerList && this.ledgerList.filter(ledger => this.showLedgerItem(ledger)).length;
  }

  capitalizeText(text) {
    return startCase(camelCase(text));
  }

  isLedgerActive(ledger) {
    const dateInactiveString = _.get(ledger, 'accountSettings.dateInactive');
    const dateInactive = new Date(dateInactiveString);
    const currentDate = new Date();

    if (dateInactiveString && currentDate > dateInactive) {
      return false;
    }

    return true;
  }

  showLedgerItem(ledger) {
    const showActiveLedger = this.showActiveLedgers ? this.isLedgerActive(ledger) : true;
    const showAccountLedger = this.showAccountLedgers ? ledger.role : true;

    return _.every([showActiveLedger, showAccountLedger]);
  }

  getSortOrder() {
    return this.sortByAlpha ? 'name' : null;
  }
}
